module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By Locations")]), _vm._v(" "), (_vm.locations == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no locations.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm11": "",
      "md11": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.locations), function(item, index) {
    return _c('v-card', {
      key: item.locationId,
      staticClass: "info",
      attrs: {
        "to": '/Trials/locations/' + item.locationId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('map-icon', {
      staticClass: "icon",
      attrs: {
        "left": ""
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.locationName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": ""
      }
    }, [_c('right-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "light": ""
      }
    }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-action', [
      [_c('app-edit-location-dialog', {
        attrs: {
          "location": _vm.location(index)
        }
      })]
    ], 2)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
      staticClass: "red darken-3",
      attrs: {
        "dark": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteTrial(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-1",
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-680244f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Locations/Archive.vue
// module id = 693
// module chunks = 1